import React from 'react'

type DualPaneLayoutProps = {
  leftContent?: React.ReactNode
  rightContent?: React.ReactNode
  reverse?: boolean
  leftClassName?: string
  rightClassName?: string
  leftBackground?: React.ReactNode
  rightBackground?: React.ReactNode
}

const DualPaneLayout = ({
  leftContent,
  rightContent,
  reverse = false,
  leftClassName = 'bg-grey-950',
  rightClassName = '',
  leftBackground,
  rightBackground
}: DualPaneLayoutProps) => {
  const defaultLeftBackground = (
    <img
      src="/background-cg-logo-640x720.svg"
      className="absolute bottom-0 left-0 w-full object-contain"
    />
  )

  return (
    <div
      className={`flex min-h-dvh ${reverse ? 'flex-row-reverse' : ''}`}
    >
      <main className={`relative flex w-full flex-col justify-center lg:w-1/2 ${leftClassName}`}>
        <div className="absolute inset-0 z-0">
          {leftBackground ?? defaultLeftBackground}
        </div>

        <div className="relative z-10 mx-auto my-6 w-full max-w-md">{leftContent}</div>
      </main>

      <aside className={`hidden relative w-full flex-col justify-center lg:flex lg:w-1/2 ${rightClassName}`}>
        <div className="absolute inset-0 z-0">
          {rightBackground}
        </div>

        <div className="relative z-10 mx-auto my-6 w-full max-w-md">{rightContent}</div>
      </aside>
    </div>
  )
}

export default DualPaneLayout
